module.exports = __webpack_public_path__ + "img/tips.0901c1b4.png";